module.exports = __webpack_public_path__ + "img/imagen3.d0db599b.png";